export var cashout_request_table = {
  data() {
    return {
      money: {
        precision: 2,
        decimal: ",",
        thousands: ".",
        masked: false
      },
      headers: [
        {
          text: this.$t("thead.name"),
          value: "name",
          search_type: "text"
        },
        {
          text: this.$t("thead.amount"),
          value: "amount",
          renderer: "currency-cents",
          search_type: "text"
        },
        {
          text: this.$t("thead.administration_fee"),
          value: "administration_fee",
          renderer: "currency-cents",
          search_type: "text"
        },
        {
          text: this.$t("thead.city"),
          value: "city",
          search_type: "text"
        },
        {
          text: this.$t("thead.iban"),
          value: "iban",
          search_type: "text"
        },
        {
          text: this.$t("thead.payment_date"),
          value: "payment_date",
          renderer: "date",
          search_type: "text"
        }
      ]
    };
  }
};

export var cashout_request_create = {
  data() {
    this.date = new Date().toISOString().substr(0, 10);

    return {
      money: {
        precision: 2,
        decimal: ",",
        thousands: ".",
        masked: false
      },
      busyCreating: false,
      valid: false,
      amount_euros: "0",
      payout_amount: 0,
      models: {
        name: this.$store.state.user.first_name,
        amount: 0,
        city: this.$store.state.user.city,
        iban: null,
        payment_date: this.formatDate(this.date),
        administration_fee: this.$store.state.config.cashout_administration_fee
      },
      rules: {
        name: [v => !!v || this.$t("rules.name_required")],
        iban: [
          v => this.isValidIBANNumber(v) || this.$t("rules.iban_invalid"),
          v => !!v || this.$t("rules.iban_required")
        ],
        amount: [
          v =>
            this.validateAmount(v) ||
            this.$t(
              "rules.amount_should_be_bigger_than_administration_fee_and_lower_than_balance"
            ),
          v => !!v || this.$t("rules.amount_required")
        ],
        city: [v => !!v || this.$t("rules.city_required")],
        payment_date: [v => !!v || this.$t("rules.payment_date_required")],
        administration_fee: [
          v => !!v || this.$t("rules.administration_fee_required")
        ]
      }
    };
  },

  watch: {
    amount_euros: function(val) {
      val = val.replace(",", ".");
      val = Math.round(val * 100);
      this.payout_amount = val - this.models.administration_fee;
      this.models.amount = val;
    }
  },

  methods: {
    addClick(route) {
      this.$router.push({
        name: route
      });
    },
    postCashout(e) {
      e.preventDefault();
      if (!this.$refs.cashoutform.validate()) {
        return;
      }
      this.busyCreating = true;
      this.$store
        .dispatch("cashout_requests/create", {
          user_uuid: this.$store.state.user.uuid,
          organization_uuid: this.$store.state.config.uuid,
          models: this.models
        })
        .then(response => {
          this.$store.commit("viewstate/notify", {
            text: this.$t("success.cashout_request_created"),
            color: "success"
          });
          this.$store.commit(
            "cashout_requests/add",
            response.data[Object.keys(response.data)[0]]
          );
          this.$router.push("/cashout-requests");
        })
        .catch(() => {
          this.$store.commit("viewstate/notify", {
            text: this.$t("error.cashout_request_failed"),
            color: "error"
          });
        })
        .finally(() => {
          this.busyCreating = false;
        });
    },
    formatDate(date) {
      if (!date) {
        return null;
      }
      const [year, month, day] = date.split("-");
      return `${day}-${month}-${year}`;
    },
    isValidIBANNumber(input) {
      var CODE_LENGTHS = {
        AD: 24,
        AE: 23,
        AT: 20,
        AZ: 28,
        BA: 20,
        BE: 16,
        BG: 22,
        BH: 22,
        BR: 29,
        CH: 21,
        CR: 21,
        CY: 28,
        CZ: 24,
        DE: 22,
        DK: 18,
        DO: 28,
        EE: 20,
        ES: 24,
        FI: 18,
        FO: 18,
        FR: 27,
        GB: 22,
        GI: 23,
        GL: 18,
        GR: 27,
        GT: 28,
        HR: 21,
        HU: 28,
        IE: 22,
        IL: 23,
        IS: 26,
        IT: 27,
        JO: 30,
        KW: 30,
        KZ: 20,
        LB: 28,
        LI: 21,
        LT: 20,
        LU: 20,
        LV: 21,
        MC: 27,
        MD: 24,
        ME: 22,
        MK: 19,
        MR: 27,
        MT: 31,
        MU: 30,
        NL: 18,
        NO: 15,
        PK: 24,
        PL: 28,
        PS: 29,
        PT: 25,
        QA: 29,
        RO: 24,
        RS: 22,
        SA: 24,
        SE: 24,
        SI: 19,
        SK: 24,
        SM: 27,
        TN: 24,
        TR: 26
      };
      var iban = String(input)
          .toUpperCase()
          .replace(/[^A-Z0-9]/g, ""), // keep only alphanumeric characters
        code = iban.match(/^([A-Z]{2})(\d{2})([A-Z\d]+)$/), // match and capture (1) the country code, (2) the check digits, and (3) the rest
        digits;
      // check syntax and length
      if (!code || iban.length !== CODE_LENGTHS[code[1]]) {
        return false;
      }
      // rearrange country code and check digits, and convert chars to ints
      digits = (code[3] + code[1] + code[2]).replace(/[A-Z]/g, function(
        letter
      ) {
        return letter.charCodeAt(0) - 55;
      });
      // final check
      return this.mod97(digits);
    },
    mod97(string) {
      var checksum = string.slice(0, 2),
        fragment;
      for (var offset = 2; offset < string.length; offset += 7) {
        fragment = String(checksum) + string.substring(offset, offset + 7);
        checksum = parseInt(fragment, 10) % 97;
      }
      if (checksum === 1) {
        return true;
      }
      return false;
    },
    validateAmount(val) {
      val = val.replace(",", ".") * 100;
      if (isNaN(val)) {
        return false;
      }
      if (val == 0.0) {
        return false;
      }
      let user_balance = this.$store.state.user.balance
        ? this.$store.state.user.balance
        : 0;
      if (
        val > user_balance ||
        val < this.$store.state.config.cashout_administration_fee
      ) {
        return false;
      }
      return true;
    }
  }
};
